import Card from "../../../shared/components/Card";
import Flex from "../../../shared/components/Flex";
import Padding from "../../../shared/components/Padding";
import Spacer from "../../../shared/components/Spacer";
import { SensorDataDto } from "../api/sensorDataApi";
import Text from "../../../shared/components/Text";
import Pill from "../../../shared/components/Pill";
import SensorStatusBoardItemStyle from "./css/SensorStatusBoardItem.module.css";
import { useAppDispatch, useAppSelector } from "../../../shared/store/store";
import { setSelectedSensor } from "../slice/sensorDashboardSlice";
import useGetStatusMessage from "../hooks/useStatusFilter";
import statusToColor from "../utils/statusToColor";
import { useMemo } from "react";
import useDevice, { useSmallDevice } from "../../../shared/hooks/useDevice";
import { debug } from "node:console";
import { statusGroupFromStatus } from "../utils/useSensor";

type SensorStatusBoardItemProps = Partial<SensorDataDto>;

function SensorStatusBoardItem({
    imei,
    regionId,
    sensorLat,
    sensorLot,
    sensorMngDept,
    sensorMngNo,
    sensorAddress,
    lastStatus,
    lastHumidity,
    lastTmpr,
    lastWind,
    sensorRemark,
    regionName,
    sensorInstallAt,
    lastDatetime,
    createAt,
    updateAt,
    sensorAlias,
    sensorStatusGrp,
    isNew,
}: SensorStatusBoardItemProps) {
    const dispatch = useAppDispatch();
    const { processingMap, isEmpty } = useGetStatusMessage();
    const device = useDevice();
    const isMobile = device === "mobile";
    const handleClick = () => {
        dispatch(setSelectedSensor({
            imei,
            regionId,
            sensorLat,
            sensorLot,
            sensorMngDept,
            sensorMngNo,
            sensorAddress,
            lastStatus,
            lastHumidity,
            lastTmpr,
            lastWind,
            sensorRemark,
            regionName,
            sensorInstallAt,
            lastDatetime,
            createAt,
            updateAt,
            sensorAlias,
            isNew
        } as SensorDataDto));
    };
    const smallDevice = useSmallDevice();

    const sensorStatusNames = useAppSelector(state => state.sensorStatusName);
    // 디테일한 상태 정보 가져오기 (codeName: 살얼음경보 등, codeGroupName: 경보/주의/안전 등)

    if(!sensorStatusGrp || processingMap.size === 0) return null;

    return (
        <Card 
            backgroundColor="#F5F7F9"
            border={0} 
            shadow={0} 
            shadowAlpha={0.08} 
            className={SensorStatusBoardItemStyle["sensor-status-board-item"]}
            onClick={handleClick}
            style={{ cursor: "pointer" }}
        >
            <Padding paddingX={isMobile ? 6 : 20} paddingLeft={isMobile ? 6 : 20} paddingY={10} paddingBottom={0} paddingTop={16}>
                <Card fullWidth style={{boxShadow: "0 0 6px 0 #3E63ED2E"}}>
                    <Padding 
                        padding={8}
                        paddingLeft={12}
                    >
                        <Flex justifyContent="space-between" alignItems="center">
                            {/* <Text color={"rgba(153, 153, 153, 1)"}>{sensorMngNo}</Text> */}
                            <Pill padding={0} style={{ border: "none"}} backgroundColor="transparent" icon={<Flex justifyContent="center" alignItems="center" className={SensorStatusBoardItemStyle["sensor-icon"]}><img alt="" src={"/images/ico_star.svg"}/></Flex>} width={"fit-content"} text={<Text color={"rgba(62, 99, 237, 1)"} weight={"semibold"} size={14}>{sensorAlias}</Text>}/>
                            <Pill
                                style={{borderRadius: 4}}
                                border={0}
                                height={25}
                                paddingY={4}
                                width={"14ch"}
                                paddingX={16}
                                backgroundColor={statusToColor(statusGroupFromStatus(lastStatus)).backgroundColor}
                                text={<Text size={"12px"} weight={"semibold"} color={statusToColor(statusGroupFromStatus(lastStatus)).color}>{lastStatus}</Text>}
                                />
                        </Flex>
                    </Padding>
                </Card>
            </Padding>
                <Padding padding={isMobile ? 6 : 20} paddingRight={isMobile ? 6 : 20} paddingY={12} paddingBottom={16}>
                <Flex flexDirection="column" gap={12}>
                        <Padding paddingX={12} paddingY={0}>
                            <Flex gap={4}>
                                <img src="/images/ico_location.png" alt="위치" width={10} height={15} />
                                <Text noWrap={false} style={{maxWidth: "100%"}} weight={"semibold"} size={14}>{sensorAddress}</Text>
                            </Flex>
                        </Padding>
                        <Card fullWidth padding={0} shadow={0} border={0} >
                            <Flex gap={isMobile ? 2 : 10} className={SensorStatusBoardItemStyle["no-scrollbar"]} justifyContent="space-between" style={{overflowX: "auto"}}>
                                <Pill
                                    border={0}
                                    padding={12}
                                    paddingRight={2}
                                    icon={<img src="/images/ico_temp_red.png" style={{ display: "block" }} alt="온도" />}
                                    text={
                                        <Flex noWrap>
                                            { !smallDevice && <Text size={14} weight={"semibold"}>온도</Text>} <Text style={{width: smallDevice ? "3ch" : "4.2ch"}} textAlign={"right"} size={14}>{lastTmpr ? `${lastTmpr}` : "-"}</Text><Text size={14}>{"℃"}</Text>
                                        </Flex>
                                    }
                                />
                                <Pill
                                    border={0}
                                    padding={12}
                                    paddingX={0}
                                    icon={<img src="/images/ico_humidity.png" style={{ display: "block" }} alt="습도" />}
                                    text={
                                            <Flex noWrap>
                                                { !smallDevice && <Text size={14} weight={"semibold"}>습도</Text>} <Text style={{width: smallDevice ? "3.5ch" : "4ch"}} textAlign={"right"} size={14}>{lastHumidity ? `${lastHumidity}` : "-"}</Text><Text size={14}>{"%"}</Text>
                                            </Flex>
                                    }
                                />
                                <Pill
                                    border={0}
                                    padding={12}
                                    paddingLeft={2}
                                    icon={<img src="/images/ico_wind.png" style={{ display: "block" }} alt="풍속" />}
                                    text={
                                        <Flex noWrap>
                                            { !smallDevice && <Text size={14} weight={"semibold"}>풍속</Text>} <Text style={{width: smallDevice ? "2.5ch" : "4ch"}} textAlign={"right"} size={14}>{lastWind ? `${lastWind}` : "-"}</Text><Text size={14}>{"m/s"}</Text>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Card>
                </Flex>
            </Padding>

            
        </Card>
    )
}

export default SensorStatusBoardItem;